<template>
  <v-dialog
    v-model="visible"
    max-width="350"
  >
    <v-card>
      <v-card-title class="headline">{{ this.$t('logout_dialog_title') }}</v-card-title>
      <v-card-text>{{ this.$t('logout_dialog_body') }}</v-card-text>
      <v-card-actions>
        <v-btn flat @click="close">
          {{ this.$t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          flat="flat"
          @click="logout(true)"
        >
          {{ this.$t('logout_dialog_yes') }}
        </v-btn>
        <v-btn
          flat="flat"
          @click="logout(false)"
        >
          {{ this.$t('logout_dialog_no') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script> 
  export default {
    name: 'logout-dialog',
    data () {
      return {
      }
    },
    props: {
      visible: {
        type: Boolean, 
        default: false
      },
    },
    methods: {
      close() {
        if (!this.visible)
          return
        this.$emit('update:visible', false)
      },
      logout(eraseData) {
        // TODO: show loader?
        this.$store.dispatch('logout', eraseData).then(() => {
          this.$router.replace({name:'Login'})
          this.close()
        })
      } 
    }
  }
</script>
